import React, { useState } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { CustomDialog } from "../../../../../../../../common/components";
import { translate } from "../../../../../../../../common/providers";
import { SKIP_CONTENT_BOX_DELETE_CONFIRM_KEY } from "../../../../../../constants/constants";

const ConfirmationDeleteDialog = ({ open, onClose, onSubmit }) => {
	const [skipConfirm, setSkipConfirm] = useState(
		() => localStorage.getItem(SKIP_CONTENT_BOX_DELETE_CONFIRM_KEY) === "true"
	);
	const handleChangeSkipConfirm = (e) => {
		const { checked } = e.target;
		setSkipConfirm(checked);
		if (checked) {
			localStorage.setItem(SKIP_CONTENT_BOX_DELETE_CONFIRM_KEY, "true");
		} else {
			localStorage.removeItem(SKIP_CONTENT_BOX_DELETE_CONFIRM_KEY);
		}
	};
	return (
		<CustomDialog
			open={open}
			submitLabel={translate("notes.central-panel.editor-actions.delete.dialog.confirm.submit")}
			title={translate("notes.central-panel.editor-actions.delete.dialog.confirm.title")}
			onClose={onClose}
			onSubmit={onSubmit}
		>
			<FormControlLabel
				control={<Checkbox checked={skipConfirm} size="small" onChange={handleChangeSkipConfirm} />}
				label={translate("notes.central-panel.editor-actions.delete.dialog.confirm.skip")}
			/>
		</CustomDialog>
	);
};

export default ConfirmationDeleteDialog;
